<template>
  <div class="page-box">
    <krpanoView @krpanoReady="panoReady"></krpanoView>

    <!-- 实时访问热度值 -->
    <actualTimePopularity />

    <!-- <div class="menu-icon" @click="handleMenuShow"></div> -->
    <div class="menu-icon" @click="handleMenuShow">
      <!-- <i class="menu-icon-icon"></i> -->
      展区导航
    </div>
    <transition name="fade">
      <menu-list :krpano="krpano" @openCX="handleOpenCX" v-if="menuShow" :sceneName="sceneName" @closeMenu="closeMenu"></menu-list>
    </transition>
    <!-- 自动观展 -->

    <div class="bottom-option-center-box">
      <div class="bottom-option-center" @click="toggleAutoView" ref="bottomOptionP">
        <!--        <div class="bottom-option-center">-->
        <div class="bottom-option-center-hover"></div>
        <div class="bottom-option-text">
          {{ autoView ? "停止" : "360°环顾" }}
        </div>
      </div>
      <div class="bottom-option-top" @click="goHead"></div>
      <div class="bottom-option-bottom" @click="goPanoBack"></div>
    </div>
    <!-- 创新100+展区按钮 -->
<!--    <div class="small-cquestion-icon" @click="handleSmallCquestionShow">创新100+展区</div>-->
    <div class="small-cquestion-icon" @click="handleOpenCX">创新100+</div>
 

    <right-option @candleClick="candleClick" @openMessage="openMessage" :krpano="krpano"></right-option>
    <!-- <right-bottom :krpano="krpano"></right-bottom> -->
    <imgSwiper class="swiper-box" v-if="imgHotspotShow" @closeSwiper="closeSwiper" :baseFile="baseFile"
      :imgNowIndex="imgNowIndex" :imgTotal="imgTotal" :baseUrl="baseUrl"></imgSwiper>
    <textHotpot :textIndex="textIndex" class="hotspot-text-box" v-if="textHotpotShow" @closeHot="closeTextHot">
    </textHotpot>
    <videoHotspot v-if="videoShow" @closeVideo="closeVideo" :guid="guid"></videoHotspot>
    <liveHotspot v-if="LiveShow" @closeLive="closeLive" :zhiboId="zhiboId"></liveHotspot>
    <audioHotspot v-if="audioShow" @closeAudio="closeAudio" :audioSrc="audioSrc"></audioHotspot>
    <leaveMessage ref="leaveMessage" @closeMessage="closeMessage"></leaveMessage>
    <div class="landscape-tip-box" v-if="landscape">
      <div class="landscape-tip"></div>
    </div>
    <messageScroll />
    <innvateBoutique ref="innvateBoutique" v-if="showCX" @close="closeCX"></innvateBoutique>
<!--    <guidePage v-if="guideShow" @iknow="handleIknow" />-->
  </div>
</template>

<script>
import krpanoView from "@/components/phone/krpanoView";
import imgSwiper from "@/components/phone/imgSwiper";
import textHotpot from "@/components/phone/textHotspot";
import videoHotspot from "@/components/phone/videoHotspot";
import liveHotspot from "@/components/phone/liveHotspot";
import audioHotspot from "@/components/phone/audioHotspot";
import rightOption from "@/components/phone/rightOption";
import rightBottom from "@/components/phone/rightBottom";
import menuList from "@/components/phone/menuList";
import leaveMessage from "@/components/phone/leaveMessage";
 
import actualTimePopularity from "@/components/phone/actualTimePopularity/index";
import guidePage from "@/components/phone/guidePage";
import messageScroll from '@/components/phone/messageScroll';
import innvateBoutique from "../../../components/phone/innvateBoutique.vue";
import sceneData from "../../../utils/sceneData";
import {enterpriseInfo, giveThumbsUp, cityInfo} from "../../../utils/tools";
import {close_music, init_music, open_music, play_music} from "../../../utils/audio";
export default {
  components: {
    imgSwiper,
    krpanoView,
    textHotpot,
    rightOption,
    rightBottom,
    menuList,
    videoHotspot,
    leaveMessage,
    audioHotspot,
    actualTimePopularity,
    guidePage,
    messageScroll,
    liveHotspot,
    innvateBoutique
  },
  data() {
    return {
      krpano: "",
      imgHotspotShow: false,
      textHotpotShow: false,
      textIndex: "",
      flowerShow: false,
      imgNowIndex: "",
      imgTotal: "",
      baseUrl: "",
      baseFile: "",
      candleShow: false,
      menuShow: false,
      videoShow: false,
      guid: "",
      sceneName: "",
      // messageShow: false,
      landscape: false,
      audioShow: false,
      audioSrc: "",
      // 创新100+
      canswerShow: false,
      guideShow: true,
      LiveShow: false,
      zhiboId: "",
      autoView: false,
      timerLine: "",
      showCX:false
    };
  },
  methods: {
    panoReady(pano) {
      this.krpano = pano;
      init_music();
    },
    showImgHotspot(baseFile, baseUrl, nowIndex, total) {
      this.imgHotspotShow = true;
      this.baseFile = baseFile;
      this.baseUrl = baseUrl;
      this.imgNowIndex = nowIndex;
      this.imgTotal = total;
    },
    closeSwiper() {
      this.imgHotspotShow = false;
      this.baseFile = "";
      this.baseUrl = "";
      this.imgNowIndex = "";
      this.imgTotal = "";
    },
    showTextHotspot(textIndex) {
      this.textHotpotShow = true;
      this.textIndex = textIndex;
    },
    closeTextHot() {
      this.textHotpotShow = false;
      this.textIndex = "";
    },
    closeCandle() {
      this.candleShow = false;
    },
    candleClick() {
      this.candleShow = true;
    },
    closeMenu() {
      this.menuShow = false;
    },
    handleMenuShow() {
      this.menuShow = true;
    },
    // 创新100+
    handleSmallCquestionShow() {
      this.canswerShow = true;

      // 打开首次的讲解视频
      this.$nextTick(() => {
        this.$refs.canswer.openAnwser();
      })
    },
    handleCloseCanswer() {
      this.canswerShow = false;
    },
    mediaOpenAudio() {
      close_music()
    },
    mediaCloseAudio() {
     open_music()
    },
    closeVideo() {
      this.videoShow = false;
      this.mediaCloseAudio()
    },
    showVideo(guid) {
      this.guid = guid;
      this.videoShow = true;
      this.mediaOpenAudio()
    },
    showLive(zhiboId) {
      this.zhiboId = zhiboId;
      this.LiveShow = true;
      this.mediaOpenAudio()
    },
    closeLive() {
      this.LiveShow = false;
      this.mediaCloseAudio()
    },
    openAudio(src) {
      this.audioSrc = src;
      this.audioShow = true;
      this.mediaOpenAudio()
    },
    closeAudio() {
      this.audioShow = false;
      this.mediaCloseAudio();
    },
    locationStart(audioSr,bgaudioSrc) {

      this.sceneName = this.krpano.get("xml.scene");
   
      var nowSceneName = this.sceneName.split("_");
      play_music(audioSr,bgaudioSrc)
    },

    openMessage() {
      // this.messageShow = true;
      this.$refs.leaveMessage.openMessage();
    },
    closeMessage() {
      // this.messageShow = false;
      this.$refs.leaveMessage.closeMessage();
    },
    origentChange() {
      var orientation = window.orientation;

      switch (orientation) {
        case 90:

        case -90:
          orientation = "landscape"; //这里是横屏
          this.landscape = true;
          break;

        default:
          orientation = "portrait"; //这里是竖屏
          this.landscape = false;
          break;
      }
    },
    // 引导页面 - 我知道了
    handleIknow() {
      // this.guideShow = false;
      init_music()
    },
    // 自动巡游
    toggleAutoView() {
      this.autoView = !this.autoView;

      if (this.autoView) {
        this.krpano.set("autorotate.enabled", true);
        this.bombtimer(0);
      } else {
        clearInterval(this.timerLine);
        this.krpano.set("autorotate.enabled", "false");
      }
    },
    bombtimer(timer) {
      var that = this;
      var rotateState = this.krpano.get("autorotate.enabled");
      if (rotateState) {
        this.autoView = true;
        timer++;
       
        this.timeLine = setTimeout(function () {
          that.bombtimer(timer);
        }, 1000);

        var rotateSpeed = Math.abs(this.krpano.get("autorotate.speed"));
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1;
        var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
        var isIE11 = userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
        if (isIE) {
          if (isIE11 || isEdge) {
            rotateSpeed = 10;
          }
        }

        var timeAll = 350 / rotateSpeed;
        timeAll += this.krpano.get("autorotate.waittime");
        if (timer >= timeAll) {
          timer = 0;
      
          this.nextscene();
        }
      }
    },
    nextscene() {
      var nowSceneName = this.krpano.get("xml.scene");
      var sceneIndex = this.getIndex(nowSceneName, sceneData);
      sceneIndex++;
      if (sceneIndex >= sceneData.length) {
        sceneIndex = 0;
      }
      this.krpano.call(
        "loadscene(" +
        sceneData[sceneIndex] +
        ",null, MERGE, OPENBLEND(1.0, -0.5, 0.3, 0.8, linear));"
      );
    },
    getIndex(indexName, nameArr) {
      for (var i = 0; i < nameArr.length; i++) {
        if (indexName === nameArr[i]) {
          return i;
        }
      }
    },
    // 自动巡游end
    giveThumbsUpView() {
      let scene_name = this.krpano.get("xml.scene");
      let zone = scene_name.split("_")[1];
      let sceneShortName = scene_name.split("_")[1] + "_" + scene_name.split("_")[2]
      if("1" == zone){//央企展区投票
        let activeEnterprise = enterpriseInfo.filter(item => item.sceneName == sceneShortName)[0]
        giveThumbsUp(15982, activeEnterprise.groupId, activeEnterprise.id)
      }else if ("2" == zone){//地方展区投票
        let activeCity = cityInfo.filter(item => item.sceneName == sceneShortName)[0]
        giveThumbsUp(15982, activeCity.groupId, activeCity.id)
      }else {//序厅为央企展区随机投票
        const random = (min, max) => Math.floor(Math.random() * (max - min) + min); //随机数方法
        let index = random(0, enterpriseInfo.length); //生成一个从最小值为0 最大值为数组长度的随机数
        giveThumbsUp(15982, enterpriseInfo[index].groupId, enterpriseInfo[index].id)//随机给央企展区投票
      }

    },
    goHead() {
      var sceneIndex = this.krpano.get("scene[get(xml.scene)].index");
      sceneIndex++;
      if (sceneIndex >= this.krpano.get("scene.count")) {
        sceneIndex = 0;
      }
      var newSceneName = this.krpano.get("scene[" + sceneIndex + "].name");
      this.krpano.call(
        "loadscene(" +
          newSceneName +
          ",null, MERGE, OPENBLEND(1.0, -0.5, 0.3, 0.8, linear));"
      );
      // this.giveThumbsUpView();
    },
    // 后退
    goPanoBack() {
      var sceneIndex = this.krpano.get("scene[get(xml.scene)].index");
      sceneIndex--;
      if (sceneIndex < 0) {
        sceneIndex = this.krpano.get("scene.count") - 1;
      }
      var newSceneName = this.krpano.get("scene[" + sceneIndex + "].name");

      this.krpano.call(
        "loadscene(" +
          newSceneName +
          ",null, MERGE, OPENBLEND(1.0, -0.5, 0.3, 0.8, linear));"
      );
      // this.giveThumbsUpView();
    },
    handleOpenCX(){
      this.showCX = true
      window.goldlog.record("/spec.1.1", "", "snsScene=创新100+&product=phoneweb&pagename=云上2023年中国品牌博览会", "")
    },
    closeCX(){
      this.showCX = false
    }
  },
  mounted() {
    var that = this;
    let startscene = this.$route.query.startscene
    if (startscene) {
      this.$nextTick(() => {
        this.krpano.call(
          "loadscene(" +
          startscene +
          ",null, MERGE, OPENBLEND(1.0, -0.5, 0.3, 0.8, linear));"
        );
      })

    }


    document.addEventListener("touchend", function (e) {

      if (that.$refs.bottomOptionP) {
        let isSelf = that.$refs.bottomOptionP.contains(e.target)
        // 移动端调试工具打开
        //  let consoleDom = document.getElementById("__vconsole")
        // if (!isSelf && !consoleDom.contains(e.target) ) {
          // 关闭
          if(!isSelf){
          that.autoView = false
          that.timerLine && clearInterval(that.timerLine);
          that.krpano.set("autorotate.enabled", "false");
        }
      }
    })

    window.showTextHotspot = this.showTextHotspot;
    window.popImg = this.showImgHotspot;
    window.popVideo = this.showVideo;
    window.locationStart = this.locationStart;
    window.popAudio = this.openAudio;
    window.popLive = this.showLive;
    // window.openFlower = this.candleClick;
    window.nav_front = this.goHead;
    window.nav_behind = this.goPanoBack;

    that.origentChange();

    window.addEventListener(
      "orientationchange",
      function () {
        that.origentChange();
      },
      false
    );
  },
  created() {
    
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  width: 100%;
  height: 100%;
  position: relative;

  @mixin background-com {
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .nav-head {
    width: 100%;
    height: 1.2rem;
    @include background-com();
    background-image: url("../../../assets/img/phone/head-bg.png");
    position: absolute;
    top: 0;
    left: 0;
  }

  .auto-box {
    width: 2.73rem;
    height: 2.73rem;
    background-image: url("../../../assets/img/phone/auto.png");
    @include background-com();
    position: absolute;
    left: 50%;
    margin-left: -1.365rem;
    bottom: 1.2rem;
    text-align: center;
    line-height: 2.73rem;

    .auto-text {
      color: #ffffff;
      font-size: 0.16rem;
    }
  }

  .bottom-option-center-box {
    width: 4.88rem;
    height: 4.88rem;
    @include background-com();
    // background-image: url("../assets/img/bottom-option-bg.png");
    background-image: url("../../../assets/img/center-btn/center-btn-bg.png");
    position: absolute;
    bottom: 1.2rem;
    left: 50%;
    margin-left: -2.44rem;
    text-align: center;

    .bottom-option-center {
      width: 2rem;
      height: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1rem;
      margin-top: -1rem;
      cursor: pointer;
      // background-image: url("../assets/img/option-center-bg.png");
      background-image: url("../../../assets/img/center-btn/center-btn-anniu.png");
      @include background-com();

      .bottom-option-center-hover {
        width: 2rem;
        height: 2rem;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -1rem;
        margin-top: -1rem;
        // background-image: url("../assets/img/option-center.png");
        background-image: url("../../../assets/img/center-btn/center-btn-anniu.png");
        @include background-com();
      }



      .bottom-option-text {
        font-size: 0.36rem;
        color: #ffffff;
        text-align: center;
        width: 100%;
        height: 0.6rem;
        line-height: 0.6rem;
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -0.3rem;
      }
    }

    .bottom-option-top {
      width: 1rem;
      height: 0.56rem;
      background-image: url("../../../assets/img/option-top.png");
      @include background-com();
      position: absolute;
      left: 50%;
      margin-left: -0.5rem;
      top: 0.6rem;
      cursor: pointer;


    }

    .bottom-option-bottom {
      width: 1rem;
      height: 0.56rem;
      background-image: url("../../../assets/img/option-bottom.png");
      @include background-com();
      position: absolute;
      left: 50%;
      margin-left: -0.5rem;
      bottom: 0.6rem;
      cursor: pointer;


    }
  }

  .candle-box {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;

    .candle-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }

    .candle-qrcode-box {
      width: 3rem;
      height: 3rem;
      background-color: rgba($color: #000000, $alpha: 0.7);

      position: absolute;
      right: 1.1rem;
      top: 5rem;
      text-align: center;
      padding-top: 0.3rem;
      border-radius: 0.16rem;

      .candle-qrcode {
        width: 2rem;
        height: 2rem;
        background-color: #ffffff;
        padding: 0.07rem;
        display: inline-block;

        img {
          width: 100%;
          height: 100%;
        }

        .candle-qrcode-area {
          width: 100%;
          height: 100%;
        }
      }

      .qrcode-text {
        color: #ffffff;
        font-size: 0.24rem;
        margin-top: 0.1rem;
      }
    }
  }

  .menu-icon {
    // width: 2.79rem;
    width: 2.28rem;
    height: 0.89rem;
    background-image: url("../../../assets/img/phone/menu-icon-bg.png");
    @include background-com();
    position: absolute;
    left: 0.48rem;
    bottom: 1.2rem;
    color: #ffffff;
    font-weight: 800;
    font-size: 0.26rem;
    text-align: center;
    line-height: 0.89rem;

    .menu-icon-icon {
      width: 0.39rem;
      height: 0.28rem;
      display: inline-block;
      background-image: url("../../../assets/img/phone/menu-icon-icon.png");
      @include background-com();
    }
  }

  .small-cquestion-icon {
    width: 2.28rem;
    height: 0.89rem;
    background-image: url('~@/assets/img/phone/c-btn-bg.png');
    @include background-com();
    position: absolute;
    right: 0.49rem;
    bottom: 1.2rem;
    line-height: 0.89rem;
    font-size: 0.26rem;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
  }

  .swiper-box {
    position: absolute;
    top: 0;
  }

  .landscape-tip-box {
    width: 100%;
    height: 100%;
    background-color: #000000;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000000000;

    .landscape-tip {
      width: 2.56rem;
      height: 3rem;
      background-image: url("../../../assets/img/landscape-tip.png");
      @include background-com();
      position: absolute;
      top: 50%;
      margin-top: -1.5rem;
      left: 50%;
      margin-left: -1.28rem;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s, transform 0.5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
    transform: translateX(-100%);
  }


  .fade-small-cquestion-enter-active,
  .fade-small-cquestion-leave-active {
    transition: opacity 0.5s, transform 0.5s;
  }

  .fade-small-cquestion-enter,
  .fade-small-cquestion-leave-to {
    opacity: 0;
    transform: translateY(200%);
  }
}
</style>
<style >
.candle-qrcode img {
  width: 100%;
  height: 100%;
}
</style>